import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';

@Component({})
export default class OCLink extends Mixins(BASEComponentVue) {

    @Prop({
        type: String,
        default: "",
    })
    public to!: string;

    @Prop({
        type: String,
        default: "",
    })
    public href!: string;

    @Prop({
        type: String,
        default: "_self",
    })
    public target!: string;


    @Prop({
        type: String,
        default: "",
    })
    public title!: string;

    @Emit("click")
    public click() {
    }

    public onButtonClick() {
        this.$emit("click");
    }

}
